import { PencilLine } from 'lucide-react'

import { Button } from '../../ui/Button'
import { formatCores } from '../../core/sizing'

export interface ResumableDraft {
  name: string
  cpu: number
  ram: number
  storage: number
  hostLabel: string | null
  resumePath: string
}

/** "You have an unfinished draft", with a way back into it or out of it. */
export function DraftResumeBar({ draft, onContinue, onDiscard }: { draft: ResumableDraft; onContinue: () => void; onDiscard: () => void }) {
  return (
    <div className="draft-resume">
      <PencilLine size={16} aria-hidden="true" className="draft-resume-icon" />
      <p className="draft-resume-text">
        You have an unfinished draft: <strong>{draft.name}</strong>
        {' · '}{formatCores(draft.cpu)}{' · '}{draft.ram} GB
        {draft.hostLabel ? <>{' · on '}{draft.hostLabel}</> : null}
      </p>
      <div className="draft-resume-actions">
        <Button size="sm" onClick={onContinue}>Continue draft</Button>
        <Button size="sm" variant="ghost" onClick={onDiscard}>Discard</Button>
      </div>
    </div>
  )
}
